import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../Contexts/GlobalContext';
import Header from './Header';
import MobileBreadCrumb from './MobileBreadCrumb';
import {withRouter} from 'react-router-dom';

function Header__Wrapper(props) {
    const globalContext = useContext(GlobalContext);
   
    return (
        <React.Fragment>
            {(props.location.pathname != '/Login' && props.location.pathname != '/') ?
                <div>
                    <Header></Header>
                    <MobileBreadCrumb></MobileBreadCrumb>
                </div>
                : null
            }
        </React.Fragment>
    )
}

export default withRouter(Header__Wrapper);